__turbopack_context__.v({
  "app_light_theme": "style-module-scss-module__IXBNqG__app_light_theme",
  "splitSteps": "style-module-scss-module__IXBNqG__splitSteps",
  "splitSteps__image": "style-module-scss-module__IXBNqG__splitSteps__image",
  "splitSteps__steps": "style-module-scss-module__IXBNqG__splitSteps__steps",
  "splitSteps__stepsItem": "style-module-scss-module__IXBNqG__splitSteps__stepsItem",
});
